if (!customElements.get('blog-nav')) {
  class BlogNav extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.settings = {
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        spaceBetween: 10,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        navigation: {
          prevEl: this.querySelector('.slider__arrow.arrow-left'),
          nextEl: this.querySelector('.slider__arrow.arrow-right'),
        },
        breakpoints: {
          990: {
            spaceBetween: 18,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      };

      this.slider = new Swiper(this.querySelector('.swiper'), this.settings);
    }
  }

  customElements.define('blog-nav', BlogNav);
}
